module.exports = __webpack_public_path__ + "img/iconewm.fd23487d.png";